import React, { useEffect, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import AdminNavbar from "./AdminNavbar";
import jsQR from "jsqr";
import api from "../api";

const QRScanner = () => {
  const [message, setMessage] = useState("");
  const [userInfo, setUserInfo] = useState(null);

  // === 🟢 Live Webcam Scanner ===
  useEffect(() => {
    const scanner = new Html5QrcodeScanner("reader", {
      fps: 10,
      qrbox: { width: 250, height: 250 },
    });

    const onScanSuccess = async (decodedText) => {
      scanner.clear();
      handleVerify(decodedText);
    };

    scanner.render(onScanSuccess, (err) => {
      console.warn("Live scan error:", err);
    });
  }, []);

  // === 🟢 QR Image Upload Handler ===
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async () => {
      const img = new Image();
      img.src = reader.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const context = canvas.getContext("2d");
        context.drawImage(img, 0, 0, canvas.width, canvas.height);
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, canvas.width, canvas.height);

        if (code) {
          handleVerify(code.data);
        } else {
          setMessage("❌ Could not read QR code");
          setUserInfo(null);
        }
      };
    };
    reader.readAsDataURL(file);
  };

  // === 🟢 Universal QR Verifier ===
  const handleVerify = async (qrData) => {
    // Try to parse raw College ID or structured QR
    let collegeId = qrData;
    const match = qrData.match(/College ID:\s*(\S+)/);
    if (match) collegeId = match[1];

    try {
      const res = await api.post("/verify-scan", {
        qrData: collegeId,
      });

      if (res.data.status === "success") {
        setMessage("✅ Entry Marked Successfully");
        setUserInfo(res.data);
      } else if (res.data.status === "already") {
        setMessage("⚠️ Already Marked as Attended");
        setUserInfo(res.data);
      } else {
        setMessage("❌ " + res.data.message);
        setUserInfo(null);
      }
    } catch (err) {
      console.error(err);
      setMessage("❌ Server error during verification.");
      setUserInfo(null);
    }
  };

  return (
    <div className="text-center p-6">
      <h2 className="text-2xl font-bold mb-4">Admin QR Code Scanner</h2>
      <AdminNavbar />
      {/* Webcam live scanner */}
      <div id="reader" className="mx-auto" style={{ maxWidth: 400 }}></div>

      <hr className="my-6" />

      {/* Upload QR image */}
      <h3 className="text-lg font-semibold mb-2">Upload QR Code Image</h3>
      <input type="file" accept="image/*" onChange={handleImageUpload} />

      {message && <p className="mt-4 text-blue-600 font-medium">{message}</p>}

      {userInfo && (
        <div className="mt-4 bg-gray-100 p-4 rounded shadow w-full max-w-md mx-auto">
          <h4 className="font-semibold text-lg mb-2">User Info</h4>
          <p><strong>Name:</strong> {userInfo.name}</p>
          <p><strong>College ID:</strong> {userInfo.collegeId}</p>
        </div>
      )}
    </div>
  );
};

export default QRScanner;
